import React from 'react';
import { Glass3dCard } from '../ui/glass-3d-card';
import { useLanguage } from '../../contexts/useLanguage';
import { useProductCardCartActions } from './useProductCardCartActions';

type BundleProduct = {
  productId: string;
  type: 'stay' | 'activity' | 'food';
};

export interface BundleCardData {
  _id: string;
  name: string;
  description: string;
  price: number;
  duration: number;
  products: BundleProduct[];
  imageUrls?: string[];
  isAvailable?: boolean;
}

const BundleCard: React.FC<{ bundle: BundleCardData }> = ({ bundle }) => {
  const { t } = useLanguage();
  const cart = useProductCardCartActions(
    {
      type: 'package',
      itemId: bundle._id,
      itemName: bundle.name,
      itemPrice: bundle.price,
    },
    t
  );

  const meta = `${bundle.duration} day${bundle.duration > 1 ? 's' : ''} · ${bundle.products.length} item(s)`;

  return (
    <Glass3dCard
      title={bundle.name}
      text={bundle.description}
      meta={meta}
      imageSrc={bundle.imageUrls?.[0] || null}
      isAvailable={bundle.isAvailable !== false}
      availableLabel={t('common.available') || 'Available'}
      unavailableLabel={t('common.unavailable') || 'Unavailable'}
      viewMoreLabel={t('common.viewDetails') || 'Details'}
      viewMoreHref={`/webdesigned/forfaits/${bundle._id}`}
      isLiked={cart.isLiked}
      isFavorite={cart.isFavorite}
      isInCart={cart.isInCart}
      onLike={cart.onLike}
      onFavorite={cart.onFavorite}
      onCart={cart.onCart}
      likeTitle={cart.likeTitle}
      favoriteTitle={cart.favoriteTitle}
      cartTitle={cart.cartTitle}
    />
  );
};

export default BundleCard;
